export function getDocumentsSelectionCustomTexts(
  selectedFilesAmount: number,
  selectedFoldersAmount: number,
): string[] | undefined {
  switch (true) {
    // * Files + Folders
    case !!selectedFilesAmount && !!selectedFoldersAmount:
      return ['', 'Shared.Entity.Items_selected_new'];
    // * Files
    case !!selectedFilesAmount && !selectedFoldersAmount:
      return ['Client.Documents.Document_selected', 'Client.Documents.Documents_selected'];
    // * Folders
    case !selectedFilesAmount && !!selectedFoldersAmount:
      return ['Client.Documents.Folder_selected', 'Client.Documents.Folders_selected'];
  }
}
